module.exports = __webpack_public_path__ + "img/67.b9501b22.webp";